import { common } from './common.icons';

export const IconMinus = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 2"
      className={`icon-minus ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M11.0003 1.83341H1.00033C0.541992 1.83341 0.166992 1.45841 0.166992 1.00008C0.166992 0.541748 0.541992 0.166748 1.00033 0.166748H11.0003C11.4587 0.166748 11.8337 0.541748 11.8337 1.00008C11.8337 1.45841 11.4587 1.83341 11.0003 1.83341Z"
        fill="currentColor"
      />
    </svg>
  );
};
